import React from 'react';
import styles from './Recent.module.css';

const Recent = () => {
  return (
    <div className={styles.activitiesSection}>
      <span>Recent Activity</span>
      <div className={styles.activityList}>
        <p className={styles.noActivity}>No recent activity</p>
      </div>
    </div>
  );
};

export default Recent; 